export {createLayer} from './layer-factory';



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/layer/index.js